import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1304bc4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionDetailView" }
const _hoisted_2 = { style: {"color":"#595959","font-weight":"bolder","font-size":"24px","font-family":"'楷体'"} }
const _hoisted_3 = {
  key: 0,
  style: {"color":"orange"}
}
const _hoisted_4 = {
  key: 1,
  style: {"color":"orange"}
}
const _hoisted_5 = {
  key: 2,
  style: {"color":"green"}
}
const _hoisted_6 = {
  key: 3,
  style: {"color":"orangered"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  style: {"color":"orange"}
}
const _hoisted_10 = {
  key: 1,
  style: {"color":"orange"}
}
const _hoisted_11 = {
  key: 2,
  style: {"color":"green"}
}
const _hoisted_12 = {
  key: 3,
  style: {"color":"orangered"}
}
const _hoisted_13 = {
  key: 2,
  style: {"margin-top":"10px","color":"#595959"}
}

import { onMounted, ref } from "vue";
import {
  QuestionControllerService,
  QuestionSubmitAddRequest,
  QuestionVO,
} from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import CodeEditor from "@/components/CodeEditor.vue";
import MdViewer from "@/components/MdViewer.vue";
import { useRoute, useRouter } from "vue-router";
import moment from "moment/moment";
import { useStore } from "vuex";

interface Props {
  id: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionDatailView',
  props: {
    id: { default: () => "" }
  },
  setup(__props: any) {

const store = useStore();
const route = useRoute();
const router = useRouter();
// 如果页面地址包含 question_submit，视为提交信息 详情页
const submitPage = route.path.includes("question_submit");
const question = ref<QuestionVO>();

const props = __props;

const dataList = ref([]);
const total = ref(0);
/**
 *  通过id获取 题目详细数据
 */
const loadData = async () => {
  if (submitPage) {
    console.log("提交记录");
    // changeCode("题目提交记录");
    form.value.code = "题目提交记录";
  }

  // 获取题目信息
  const res = await QuestionControllerService.getQuestionVoByIdUsingGet(
    props.id as any
  );
  if (res.code === 0) {
    question.value = res.data;
  } else {
    message.error("加载失败，" + res.message);
  }

  // 获取提交记录
  const recordRes =
    await QuestionControllerService.listQuestionSubmitVoByPageUsingPost({
      // 创建时间降序排序
      sortField: "createTime",
      sortOrder: "descend",
      questionId: question.value?.id,
      userId: store.state.user.loginUser.id,
    });

  console.log(recordRes);
  if (recordRes.code === 0) {
    dataList.value = recordRes.data.records; // 数据条数
    total.value = recordRes.data.total; // 数据总数
  } else {
    message.error("加载失败，" + res.message);
  }
};

/**
 *  页面加载时 请求数据
 */
onMounted(() => {
  loadData();
});

// 设置表单
const form = ref<QuestionSubmitAddRequest>({
  language: "java",
  code: "",
});

/**
 *  提交代码
 */
const doSubmit = async () => {
  if (!question.value?.id) {
    return;
  }

  const res = await QuestionControllerService.doQuestionSubmitUsingPost({
    ...form.value,
    questionId: question.value.id,
  });
  if (res.code === 0) {
    message.success("提交成功！");
  } else {
    message.error("提交失败！ " + res.message);
  }
};

/**
 *  向代码编辑器 响应用户输入代码 提交给父组件
 * @param value
 */
const changeCode = (value: string) => {
  form.value.code = value;
};

// 定义弹窗的显示与内容
const isModalVisible = ref(false);
const modalContent = ref(""); // 存放要显示的 Markdown 内容
const currentRecord = ref(null); // 用于弹窗时, 弹窗内元素使用(按钮响应初始化)

// 处理弹窗确认与关闭
const handleOk = () => {
  isModalVisible.value = false;
};

const handleCancel = () => {
  isModalVisible.value = false;
};

/**
 *  获取 一条提交记录并显示在弹窗中
 * @param record 提交记录
 */
const getQuestionSubmitDatail = (record: any) => {
  // 转存record 给弹窗
  currentRecord.value = record;
  // 弹窗显示
  isModalVisible.value = true;

  // 模拟获取记录的 Markdown 内容并赋值给弹窗
  modalContent.value = `### 代码记录
  \`\`\`${record.language}
  ${record.code}
  \`\`\`
  `;
};

/**
 *  获取 一条提交记录
 * @param value 题目提交id
 */
const getQuestionSubmitDatails = (value: number) => {
  return;
};

const columns = [
  {
    title: "通过",
    slotName: "judgeInfoMessage",
  },
  // {
  //   title: "提交号",
  //   dataIndex: "id",
  // },
  {
    title: "编程语言",
    dataIndex: "language",
  },
  {
    title: "运行状态",
    slotName: "status",
  },
  {
    title: "运行时间",
    slotName: "judgeInfoTime",
  },
  // {
  //   title: "运行内存",
  //   slotName: "judgeInfoMemory",
  // },
  {
    title: "提交时间",
    slotName: "createTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: [24, 24] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, { "default-active-key": "question" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "question",
                  title: "题目"
                }, {
                  default: _withCtx(() => [
                    (question.value)
                      ? (_openBlock(), _createBlock(_component_a_card, { key: 0 }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(question.value.title), 1)
                          ]),
                          extra: _withCtx(() => [
                            _createVNode(_component_a_space, { wrap: "" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.value.tags, (tag, index) => {
                                  return (_openBlock(), _createBlock(_component_a_tag, {
                                    key: index,
                                    color: "green"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_descriptions, {
                              title: "判题条件",
                              column: { xs: 1, md: 2, lg: 3 }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_descriptions_item, { label: "时间限制" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(question.value.judgeConfig.timeLimit ?? 0), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_descriptions_item, { label: "内存限制" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(question.value.judgeConfig.memoryLimit ?? 0), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_descriptions_item, { label: "堆栈限制" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(question.value.judgeConfig.stackLimit ?? 0), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(MdViewer, {
                              value: question.value.content
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "record",
                  title: "提交记录"
                }, {
                  title: _withCtx(() => [
                    _createTextVNode("提交记录")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      columns: columns,
                      data: dataList.value,
                      style: {"margin":"0 20px"}
                    }, {
                      status: _withCtx(({ record }) => [
                        (record.status === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString("Waiting")))
                          : (record.status === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString("Running")))
                            : (record.status === 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString("Finish")))
                              : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString("Warning")))
                      ]),
                      judgeInfoMessage: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            (record.status === 0 || record.status === 1)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_a_spin),
                                  _createVNode(_component_a_tag, { color: "#86909c" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString("Loading"))
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                              : (record.judgeInfo.message === 'Accepted')
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 1,
                                    color: "#7bc616"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (record.judgeInfo.message === 'Wrong Answer')
                                  ? (_openBlock(), _createBlock(_component_a_tag, {
                                      key: 2,
                                      color: "red"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (record.judgeInfo.message === null)
                                    ? (_openBlock(), _createBlock(_component_a_tag, {
                                        key: 3,
                                        color: "#86909c"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString("undefined"))
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_a_tag, {
                                        key: 4,
                                        color: "#ff7d00"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      judgeInfoTime: _withCtx(({ record }) => [
                        _createTextVNode(_toDisplayString(record.judgeInfo.time + " ms"), 1)
                      ]),
                      createTime: _withCtx(({ record }) => [
                        _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("HH:mm:ss  MM-DD")), 1)
                      ]),
                      optional: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "outline",
                              onClick: ($event: any) => (getQuestionSubmitDatail(record))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("查看 ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    _createVNode(_component_a_modal, {
                      visible: isModalVisible.value,
                      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isModalVisible).value = $event)),
                      title: "详细记录",
                      onOk: handleOk,
                      onCancel: handleCancel,
                      width: "800px",
                      bodyStyle: { maxHeight: '400px', overflowY: 'auto' }
                    }, {
                      default: _withCtx(() => [
                        (currentRecord.value && currentRecord.value.judgeInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("p", {
                                style: _normalizeStyle([{
                    color: currentRecord.value.judgeInfo.message
                      ? currentRecord.value.judgeInfo.message === 'Accepted'
                        ? 'green'
                        : 'red'
                      : 'red',
                  }, {"font-size":"24px"}])
                              }, "    " + _toDisplayString(currentRecord.value.judgeInfo.message || "Failed"), 5)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_divider, { dashed: "" }),
                        (currentRecord.value && currentRecord.value.status)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              (currentRecord.value.status === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "      运行状态: " + _toDisplayString("Waiting")))
                                : (currentRecord.value.status === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "      运行状态: " + _toDisplayString("Running")))
                                  : (currentRecord.value.status === 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "      运行状态: " + _toDisplayString("Finish")))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_12, "      运行状态: " + _toDisplayString("Warning")))
                            ]))
                          : _createCommentVNode("", true),
                        (
                  currentRecord.value &&
                  currentRecord.value.judgeInfo &&
                  currentRecord.value.judgeInfo.time !== null
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "      运行时间: " + _toDisplayString(currentRecord.value.judgeInfo.time + " ms" || "NA"), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_divider, { dashed: "" }),
                        _createVNode(MdViewer, { value: modalContent.value }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["visible"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "answer",
                  title: "答案",
                  disabled: ""
                }, {
                  title: _withCtx(() => [
                    _createTextVNode("答案")
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Content of Tab Panel 3 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              class: "form",
              model: form.value,
              layout: "inline"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  field: "language",
                  label: "编程语言",
                  style: {"min-width":"280px","margin-top":"10px","margin-bottom":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      style: { width: '320px' },
                      modelValue: form.value.language,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.language) = $event)),
                      placeholder: "请选择语言"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_option, null, {
                          default: _withCtx(() => [
                            _createTextVNode("java")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_option, null, {
                          default: _withCtx(() => [
                            _createTextVNode("cpp")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_option, null, {
                          default: _withCtx(() => [
                            _createTextVNode("python")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_option, null, {
                          default: _withCtx(() => [
                            _createTextVNode("html")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_option, { disabled: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("go")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(CodeEditor, {
              value: form.value.code,
              language: form.value.language,
              "handle-change": changeCode
            }, null, 8, ["value", "language"]),
            _createVNode(_component_a_button, {
              type: "primary",
              style: {"min-width":"150px","min-height":"20px","margin-top":"15px"},
              onClick: doSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交代码")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})